module.exports = __webpack_public_path__ + "img/offers-icon.a696edf2.svg";